import React, { Component, Fragment } from 'react';
import Navbar from '../../components/Navbar';
import { Fade } from 'react-reveal';
import './Document.css';

export default class Projects extends Component {

    render() {
        return (
            <Fragment>
                <Navbar />
                <Fade top duration="1000" delay="500">
                    <embed src={`/docs/${this.props.match.params.doc}`} />
                </Fade>
            </Fragment>
        );

    }
}


// WEBPACK FOOTER //
// ./src/pages/Document/Document.js